var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { PureComponent, createElement } from 'react';
import PropTypes from 'prop-types';
import { Carousel as AntCarousel, Icon as AntIcon } from 'antd';
import { basicPropTypes } from '../component-props';
import { extendsParentProps } from '../component-props';
import { ComponentsManager } from '@comall-backend-builder/core';
export var CarouselAPI;

(function (CarouselAPI) {
  CarouselAPI["linear"] = "linear";
  CarouselAPI["swing"] = "swing";
  CarouselAPI["scrollx"] = "scrollx";
  CarouselAPI["fade"] = "fade";
})(CarouselAPI || (CarouselAPI = {}));

var Carousel = function (_super) {
  __extends(Carousel, _super);

  function Carousel(props) {
    var _this = _super.call(this, props) || this;

    _this.renderBtns = _this.renderBtns.bind(_this);
    _this.renderPanels = _this.renderPanels.bind(_this);
    _this.handlePrevBtn = _this.handlePrevBtn.bind(_this);
    _this.handleNextBtn = _this.handleNextBtn.bind(_this);
    _this.handleGoToPanel = _this.handleGoToPanel.bind(_this);
    return _this;
  }

  Carousel.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        showArrows = _a.showArrows,
        items = _a.items,
        dots = _a.dots,
        easing = _a.easing,
        effect = _a.effect,
        vertical = _a.vertical,
        autoplay = _a.autoplay;
    var props = {
      className: className,
      style: style
    };
    var carouselProps = {
      dots: dots,
      easing: easing,
      effect: effect,
      vertical: vertical,
      autoplay: autoplay
    };
    return React.createElement("div", __assign({}, props), showArrows && items.length > 1 ? this.renderBtns() : '', React.createElement(AntCarousel, __assign({}, carouselProps, {
      ref: "carousel"
    }), this.renderPanels()));
  };
  /**
   * 渲染切换面板按钮
   */


  Carousel.prototype.renderBtns = function () {
    return React.createElement("div", null, React.createElement("div", {
      className: "carousel-btn carousel-prev-btn",
      onClick: this.handlePrevBtn
    }, React.createElement(AntIcon, {
      type: "caret-left"
    })), React.createElement("div", {
      className: "carousel-btn carousel-next-btn",
      onClick: this.handleNextBtn
    }, React.createElement(AntIcon, {
      type: "caret-right"
    })));
  };
  /**
   * 切换上一个面板
   */


  Carousel.prototype.handlePrevBtn = function () {
    this.refs.carousel.prev();
  };
  /**
   * 切换下一个面板
   */


  Carousel.prototype.handleNextBtn = function () {
    this.refs.carousel.next();
  };
  /**
   * 根据面板id跳转面板
   */


  Carousel.prototype.handleGoToPanel = function (panelNumber) {
    this.refs.carousel.goTo(panelNumber);
  };
  /**
   * 渲染走马灯面板内容
   */


  Carousel.prototype.renderPanels = function () {
    var _this = this;

    var _a = this.props,
        items = _a.items,
        children = _a.children;
    return items.map(function (itemDesc, key) {
      var component = itemDesc.component,
          otherProps = __rest(itemDesc, ["component"]);

      var ItemComponent = ComponentsManager.get(component);
      var props = extendsParentProps(__assign(__assign({}, otherProps), {
        key: key
      }), _this.props);
      return React.createElement("div", {
        key: key
      }, createElement(ItemComponent, props, children));
    });
  };

  Carousel.prototype.componentDidMount = function () {
    this.handleGoToPanel(this.props.activePanel);
  };

  Carousel.prototype.componentWillReceiveProps = function (nextProps) {
    this.handleGoToPanel(nextProps.activePanel);
  };

  Carousel.defaultProps = {
    showArrows: true
  };
  Carousel.propTypes = __assign(__assign({}, basicPropTypes), {
    // 是否显示面板指示点，默认true
    dots: PropTypes.bool,
    // 动画效果，默认linear
    easing: PropTypes.oneOf([CarouselAPI.linear, CarouselAPI.swing]),
    // 动画效果函数，默认scrollx
    effect: PropTypes.oneOf([CarouselAPI.scrollx, CarouselAPI.fade]),
    // 面板指示点是否垂直显示，默认false
    vertical: PropTypes.bool,
    // 是否自动切换，默认false
    autoplay: PropTypes.bool,
    // 是否显示上／下一个面板按钮，默认true
    showArrows: PropTypes.bool,
    // 面板集合
    items: PropTypes.array,
    // 当前需要显示的面板索引
    activePanel: PropTypes.number
  });
  return Carousel;
}(PureComponent);

export { Carousel };